import { Component, ElementRef, ViewChild } from '@angular/core';
import moment from 'moment';
import {
  Companieslist,
  Labels,
  LoginModel,
  UserPermissionsModel
} from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { ImgUploaderService } from '../../../../Services/img-uploader.service';
import { LabelaryService } from '../../../../Services/labelary.service';
import { CustomToastsService } from '../../../../Services/custom-toasts.service';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { LabelEntityType } from 'src/app/Services/enum';
import { Status } from 'src/app/enum/enum';

@Component({
  selector: 'app-labels',
  templateUrl: './labels.component.html',
  styleUrls: ['./labels.component.css']
})
export class LabelsComponent {
  @ViewChild('InputFile1') InputFile1?: ElementRef<HTMLElement>;
  @ViewChild('InputFile2') InputFile2?: ElementRef<HTMLElement>;
  activeStatus: boolean = false;
  activeColor: string = '#1e5a7d';
  inActiveColor: string = '#aab6bc';
  headerCheckboxSelected: boolean = false;
  deleteParameter: any = null; // Initialize with a default value
  deleteButtonClickedWithoutSelection: boolean = false;
  deleteButtonClickedWithSelection: boolean = false;
  isUpdated = false;
  selectedLabelIDs: string[] = [];
  selectedRowIndex: number | null = null;
  frmText: string = 'Add New Print Format';
  labels: Array<Labels> = [];
  labelsForSearch: Array<Labels> = [];
  label: Labels = new Labels();
  labelCopy: Labels = new Labels();
  labelsInput: string = '';
  labelName: string = '';
  hideAddBtn: boolean = true;
  hideUpdateBtn: boolean = true;
  arrForresult: any[] = [];
  printersType: any[] = [
    { id: 1, name: 'ZebraLabel' },
    { id: 2, name: 'ZebraTag' },
    { id: 3, name: 'ZebraBoth' }
  ];


  labelImg: string = '';
  @ViewChild('modalConfirmCloseButton')
  modalConfirmCloseButton?: ElementRef<HTMLElement>;
  previewZplCode: any;
  activeTag: number = 0;
  previewTagSize: any;
  companyID: number = 0;
  isEditable: boolean = true;
  companieslist: Array<Companieslist> = [];
  superAdmin: boolean = false;
  frontPreview: File | undefined;
  backPreview: File | undefined;
  userdata: LoginModel = new LoginModel();

  labelEntityTypes = Object.keys(LabelEntityType)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      id: LabelEntityType[key as keyof typeof LabelEntityType],
      name: key === 'Container' ? 'Bin' : key
    }))
    .filter(x => x.id !== LabelEntityType.Unknown);
    Status = Status;
  constructor(
    private permissionService: NgxPermissionsService,
    private userservice: UserserviceService,
    private imgbbService: ImgUploaderService,
    private masterservice: MasterDataSeriveService,
    private toastr: CustomToastsService,
    private lable: LabelaryService,
    private adminBreadcrumbs: AdminBreadcrumbsService
  ) { }

  ngOnInit() {
    this.userdata = this.masterservice.getUserDetailsFromStorage();
    if (this.userdata.accessRoleID == 1) {
      this.adminBreadcrumbs.updateBreadcrumbs([
        { crumbName: 'Company Management', link: 'demo' },
        { crumbName: 'Print Formats', link: '/admin/home/labels' }
      ]);
    } else {
      this.adminBreadcrumbs.updateBreadcrumbs([
        { crumbName: 'Company Config', link: 'demo' },
        { crumbName: 'Print Formats', link: '/admin/home/labels' }
      ]);
    }

    this.getAllLabel();

    this.getPermissionsByUserId();
  }

  selectCompanyID() {
    this.getAllLabel();
  }
  getActiveStatus() {
    if (this.activeStatus) {
      this.activeColor = '#aab6bc';
      this.inActiveColor = '#1e5a7d';
    } else {
      this.activeColor = '#1e5a7d';
      this.inActiveColor = '#aab6bc';
    }
  }
  showSuccess() {
    this.toastr.success('New Print Format has been successfully added.');
  }
  showUpdated() {
    this.toastr.success('Print Format has been successfully Updated.');
  }
  showError() {
    this.toastr.error('Print Format Already Exist');
  }

  clearForm() {
    this.arrForresult = [];
    this.hideAddBtn = true;
    this.hideUpdateBtn = true;
    this.frmText = 'Add New Print Format';
    this.label = new Labels();
    if (!this.label.frontPreview) {
      this.label.frontPreview = '../../../assets/dashboard/noPreview.svg';
    }
    if (!this.label.backPreview) {
      this.label.backPreview = '../../../assets/dashboard/noPreview.svg';
    }
  }

  highlightedRow(id: any) {
    this.selectedRowIndex = id;
    this.label = this.labelCopy;
  }

  uploadImage(file: any): Promise<string> {
    return new Promise((resolve, reject) => {
      if (file.length == 0) return;
      this.imgbbService.uploadImage(file).subscribe(
        (response) => {
          let displayUrl = response.url;
          resolve(displayUrl);
        },
        (error) => {
          reject('No Image');
        }
      );
    });
  }

  deleteGrade(deleteParameter: any | any[]) {
    if (Array.isArray(deleteParameter) || typeof deleteParameter === 'number') {
      if (typeof deleteParameter === 'number') {
        deleteParameter = [deleteParameter]; // Wrap the single number in an array
      }
      // Bulk delete
      const selectedIds: string = deleteParameter.join(',');
      this.masterservice.removeLabel(selectedIds).subscribe((res) => {
        if (res) {
          this.toastr.success('Print Format have been successfully deleted.');
          this.getAllLabel();
        }
      });
      this.closeModal();
      this.uncheckSelectedCheckboxes();
      this.headerCheckboxSelected = false;
      this.label.isSelected = false;
    }
  }
  uncheckSelectedCheckboxes() {
    // Reset the selected checkboxes
    this.selectedLabelIDs = [];
  }

  closeModal() {
    if (this.modalConfirmCloseButton) {
      this.modalConfirmCloseButton.nativeElement.click();
    }
  }

  finalStatus(indx: any) {
    if (this.hideUpdateBtn) {
      this.arrForresult.push(indx);
      this.arrForresult = Array.from(new Set(this.arrForresult));
      if (this.arrForresult.length > 1) {
        this.hideAddBtn = false;
      } else {
        this.hideAddBtn = true;
      }
    }
  }

  getStatus(inputIndx: any) {
    this.finalStatus(inputIndx);
  }

  async showPreview(id: number) {
    this.activeTag = id;
    let zpl = await this.generatePreviewZpl();
    if (zpl && zpl.length > 0) {
      this.generatePreview(zpl);
    } else {
      this.labelImg = '';
    }
  }

  generatePreview(zplCode: any) {
    this.labelImg = this.lable.convertZplToPng1(zplCode, this.previewTagSize);
  }

  generatePreviewZpl() {
    let Store = 'Store';
    let Color = 'Color';
    let Date = 'Date';
    let CompanyName = 'Company';
    let Department = 'Department';
    let Category = 'Category';
    let SizeText = 'Size :';
    let SizeSize = 'SM';
    let Price = '9.99';
    let Quality = 'Good';
    let BarcodeValue = '1234|4321';
    let CompanyNameLine2 = ' ';
    let Date2 = '-';
    let Brand = 'Brand';
    const currentDate = moment();
    Date = currentDate.format('MM/DD');
    Date2 = currentDate.format('MM/DD/YYYY');
    const Time = currentDate.format('HH:mm');
    const User = this.userdata?.brijjusername || '';
    const DisplayName = this.userdata?.displayName || '';

    this.labels.map((res) => {
      if (res.id == this.activeTag) {
        this.previewZplCode = res.zplCode;
        this.previewTagSize = this.extractLabelSize(res.name);
      }
    });

    if (!this.previewZplCode || this.previewZplCode.trim() === '') {
      return [];
    }

    const replacedZplCode = this.previewZplCode
      .replace(/\${CompanyName}/g, CompanyName ? CompanyName : '')
      .replace(/\${Color}/g, Color ? Color : '')
      .replace(/\${Department}/g, Department ? Department : '')
      .replace(/\${Category}/g, Category ? Category : '')
      .replace(/\${SizeText}/g, SizeText ? SizeText : '')
      .replace(/\${SizeSize}/g, SizeSize ? SizeSize : '')
      .replace(/\${Price}/g, Price ? Price : '')
      .replace(/\${Date}/g, Date ? Date : '')
      .replace(/\${Date2}/g, Date2 ? Date2 : '')
      .replace(/\${Time}/g, Time)
      .replace(/\${User}/g, User)
      .replace(/\${Name}/g, DisplayName)
      .replace(/\${DisplayName}/g, DisplayName)
      .replace(/\${BarcodeValue}/g, BarcodeValue ? BarcodeValue : '')
      .replace(/#/g, '%23')
      .replace(/\${Store}/g, Store ? Store : '')
      .replace(/\${Quality}/g, Quality ? Quality : '')
      .replace(
        /\${CompanyNameLine2}/g,
        CompanyNameLine2 ? CompanyNameLine2 : ''
      )
      .replace(/\${Brand}/g, Brand ? Brand : '');

    // Split the ZPL code into an array of lines
    const zplTemplate: string[] = replacedZplCode
      .split('\n')
      .map((line: string) => line.trim());

    return zplTemplate;
  }

  extractLabelSize(input: string): string {
    const labelNumber = input.match(/[0-9]+(\.[0-9]+)?/)?.[0] || '';
    const sizeNumber = input.match(/[Xx]\s*([0-9]+(\.[0-9]+)?)"/)?.[1] || '';

    let result = `${labelNumber}x${sizeNumber}`;
    result = this.reverseString(result);
    return result;
  }

  reverseString(inputStr: string): string {
    const parts: string[] = inputStr.split('x');
    const reversedStr: string = parts.reverse().join('x');
    return reversedStr;
  }

  async createLabel(label: Labels) {
    try {
      label.frontPreview = await this.uploadImage(this.frontPreview);
    } catch (error) {
      console.error('Error uploading front preview image:', error);
      label.frontPreview = 'null';
    }

    try {
      label.backPreview = await this.uploadImage(this.backPreview);
    } catch (error) {
      console.error('Error uploading back preview image:', error);
      label.backPreview = 'null';
    }
    let userdata = this.masterservice.getUserDetailsFromStorage();
    label.companyId = this.companyID;
    label.createdById = userdata.userId;
    label.zplCode = label.zplCode;

    this.masterservice.addUpdateLabel(label).subscribe(
      (res) => {
        if (this.isUpdated == true) {
          this.showUpdated();
          this.isUpdated = false;
        } else {
          this.showSuccess();
        }
        this.getAllLabel();
      },
      (err) => {
        this.showError();
      }
    );
  }

  getAllLabel() {
    let userdata = this.masterservice.getUserDetailsFromStorage();
    if (this.companyID == 0) {
      this.companyID = userdata.companyID;
    }
    this.masterservice.getAllLabels(this.companyID).subscribe((res: any) => {
      this.labels = res as Labels[];
      this.labels.forEach((label) => {
        if (label.printerType == 1) {
          label.printerName = 'ZebraLabel';
        } else if (label.printerType == 2) {
          label.printerName = 'ZebraTag';
        } else {
          label.printerName = 'ZebraBoth';
        }

        // Ensure labelEntityType has a default if missing from server
        if (label.labelEntityType === undefined || label.labelEntityType === null || label.labelEntityType === 0) {
          label.labelEntityType = LabelEntityType.Product;
        }
      });
      this.labelsForSearch = res as Labels[];
    });
  }

  async getLabelById(id: number) {
    this.showPreview(id);
    this.hideUpdateBtn = false;
    this.hideAddBtn = true;
    this.frmText = 'Update Print Format';
    this.highlightedRow(id);
    this.isUpdated = true;

    this.labelCopy = this.labels.find(res => res.id == id) || new Labels();

    if (!this.labelCopy.frontPreview || this.labelCopy.frontPreview == 'null') {
      this.labelCopy.frontPreview = '../../../assets/dashboard/noPreview.svg';
    }
    if (!this.labelCopy.backPreview || this.labelCopy.backPreview == 'null') {
      this.labelCopy.backPreview = '../../../assets/dashboard/noPreview.svg';
    }
    // Ensure labelEntityType has a default if missing
    if (!this.labelCopy.labelEntityType) {
      this.labelCopy.labelEntityType = LabelEntityType.Product;
    }
    // Deep copy of this.label
    this.label = JSON.parse(JSON.stringify(this.labelCopy)); // Or use cloneDeep(this.label)
  }

  handleCheckboxChange(event: any, label: any) {
    if (event.target.checked) {
      this.selectedLabelIDs.push(label.id);
    } else {
      const index = this.selectedLabelIDs.indexOf(label.id);
      if (index !== -1) {
        this.selectedLabelIDs.splice(index, 1);
      }
    }
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;
    // Update the selectedDepartmentIDs array based on headerCheckboxSelected state
    if (this.headerCheckboxSelected) {
      this.label.isSelected = true;
      this.selectedLabelIDs = this.labels.map((label) =>
        label.id.toString()
      );
    } else {
      this.selectedLabelIDs = [];
      this.label.isSelected = false;
    }
  }

  async openConfirmPopup(id: any) {
    this.getLabelById(id);
    this.highlightedRow(id);
    if (id === null) {
      this.deleteButtonClickedWithoutSelection = true;
      this.deleteButtonClickedWithSelection = false;
    } else if (Array.isArray(id) && id.length === 0) {
      this.deleteButtonClickedWithoutSelection = true;
      this.deleteButtonClickedWithSelection = false;
    } else {
      this.deleteButtonClickedWithoutSelection = false;
      this.deleteButtonClickedWithSelection = true;
      this.deleteParameter = id;
    }
  }

  search() {
    if (this.labelsInput == '') {
      this.labels = this.labelsForSearch;
    } else {
      const filteredDeptData = this.labels.filter((res: any) => {
        if (res.formatTypeDesr != null) {
          return (
            res.formatTypeDesr
              .toLowerCase()
              .includes(this.labelsInput.toLowerCase()) ||
            res.formatTypeCd
              .toLowerCase()
              .includes(this.labelsInput.toLowerCase()) ||
            res.createdDt.toLowerCase().includes(this.labelsInput.toLowerCase())
          );
        } else {
          return false;
        }
      });
      this.labels = filteredDeptData;
    }
  }

  getSearchResult(event: KeyboardEvent) {
    if (this.labelsInput == '') {
      this.labels = this.labelsForSearch;
    } else if (event.keyCode != 8) {
      this.search();
    } else {
      this.labels = this.labelsForSearch;
      this.search();
    }
  }

  getPermissionsByUserId() {
    this.userservice.getUserRolesandPerm().then((res) => {
      let permissions = res as UserPermissionsModel[];

      let perm: string[] = [];

      permissions?.forEach((pr) => {
        perm.push(pr.name);
      });

      this.permissionService.loadPermissions(perm);
    });
  }
}
